<template>
  <div class="third-box">
    <div class="outContent">
      <shopMall v-if="active == 0"></shopMall>
      <myCenter
        v-if="active == 1"
        @showSupplier="showSupplier"
        @closeWindow="closeWindow"
      ></myCenter>
    </div>
    <van-tabbar
      v-model="active"
      z-index="999"
      active-color="#FB9B0D"
      inactive-color="#333333"
      safe-area-inset-bottom
    >
      <van-tabbar-item>
        <span>商城</span>
        <template #icon="props">
          <img
            :src="props.active ? icon1.active : icon1.inactive"
            class="btm-icon"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>我的</span>
        <template #icon="props">
          <img
            :src="props.active ? icon2.active : icon2.inactive"
            class="btm-icon"
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>

    <van-popup
      v-model="thirdYearShow"
      class="thirdYearPopup"
      :close-on-click-overlay="false"
    >
      <p class="title">三年购白皮书</p>
      <div class="content">
        <p>
          尊敬的用户，欢迎您使用销巴生活APP三年购专区，请认真阅读此须知，以便您能对“三年购”的规则有更深的认知和理解，也便于我们更好地为您服务，感谢您的
          配合与支持！
        </p>
        <p>
          销巴生活以消费商理念为核心，秉持为用户创造消费增值、减轻消费压力为宗旨，经过多年的务实发展，已发展为一个具有丰富消费场景的综合性平台。为进一步
          弘扬消费商的价值理念，也为给广大用户提供福利，回馈社会，特推出三年购专区。
        </p>
        <p>一、“三年购”简介</p>
        <p>
          “三年购”是销巴生活APP平台内一个新上线的购物专区，销巴会员购买专区内的商品，用户支付商品售价等额的消费金，平台将按照用户实际支付金额分36月按期
          以红包形式全额退还。
        </p>
        <p>
          购物流程：用户在三年购专区选择意向商品——下单并完成支付——供货商发货并上传物流信息——用户确认收货——次月起开始享受消费金补贴。
        </p>
        <p>二、享受“三年购”的条件</p>
        <p>1、用户必须注册成为销巴生活APP会员，并根据平台规则完成实名认证。</p>
        <p>
          2、只有真实的消费行为才能享受平台的相关福利，用户不得进行虚假交易、买卖积分、刷单等任何违反平台规则或违法的行为。一经发现，平台有权利冻结或注
          销该账户，并清除账户内的积分、红包、余额等。若用户的行为给平台或第三方造成损失的，还应当赔偿由此造成的一切经济损失。
        </p>
        <p>三、售后服务条款</p>
        <p>
          用户在三年购专区内购买的商品，可获得与平台所售其他商品同等的售后服务，售后服务将由平台合作的供货商提供，销巴平台将对供货商进行监管，以最大程度
          地保障消费者的权利。
        </p>
        <p>
          若用户未做好验收工作即确认收货，或因个人原因导致商品质量问题的，供货商有权不提供售后服务。
        </p>
        <p>四、补充说明</p>
        <p>
          考虑到销巴商业模式的特殊性，经过精确的算法计算，平台对“三年购”商品零售模式做如下规划：
        </p>
        <p>1、“三年购”专区于2021年7月正式上线，持续至2022年12月31日。</p>
        <p>
          2、2023年1月1日起，该模式将升级为“四年购”，即消费补贴周期变为48个月。“四年购”持续时间为两年，于2024年12月31日止。
        </p>
        <p>
          3、2025年1月1日起，该模式将升级为“五年购”，即消费补贴周期变为60个月，“五年购”持续时间为两年，于2026年12月31日止。
        </p>
        <p>
          4、2027年1月1日起，该模式将升级为“六年购”，即消费补贴周期变为72个月，“六年购”持续时间为永久。
        </p>
        <p>
          5、三年购专区用户享受的消费金补贴，金额保留小数点后两位，以四舍五入的方式计算。
        </p>
        <p>6、销巴集团对上述所有规则拥有最终解释权。</p>
        <p>如您有任何疑问，可致电销巴官方客服，客服热线为400-0571-671。</p>
      </div>
      <p class="thirdYear-btn">
        <span class="cancle" @click="cancle">取消</span>
        <span class="agree" @click="agree">同意</span>
      </p>
    </van-popup>

    <Guide v-model="guideVisible" />
  </div>
</template>
<script>
import shopMall from "./index.vue";
import myCenter from "./my.vue";
import Guide from "./guide.vue";

export default {
  data() {
    return {
      active: 0,
      icon1: {
        active: require("@/assets/third/guide/tab_active_icon1.png"),
        inactive: require("@/assets/third/guide/tab_icon1.png"),
      },
      icon2: {
        active: require("@/assets/third/guide/tab_active_icon2.png"),
        inactive: require("@/assets/third/guide/tab_icon2.png"),
      },
      showAggre: false,
      showGuide: false,
      thirdYearShow: false, //白皮书
      showBox: false,
      guideVisible: false,
    };
  },
  created() {
    this.showAggre = localStorage.getItem("thirdYearShowAggre"); //白皮书
    this.showGuide = localStorage.getItem("thirdLuckyGuide"); //抽奖引导

    if (this.showAggre) {
      if (!this.showGuide) {
        this.guideVisible = true;
      }
    } else {
      this.thirdYearShow = true;
    }
    // this.$api.setToken(this.$route.query.token);
  },
  components: {
    shopMall,
    myCenter,
    Guide,
  },
  methods: {
    agree() {
      this.thirdYearShow = false;
      localStorage.setItem("thirdYearShowAggre", true);
      if (!this.showGuide) {
        this.guideVisible = true;
      }
    },
    cancle() {
      this.params("", "", "goBack");
    },
    closeWindow() {},
    showSupplier(e) {
      this.showBox = e;
    },
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    window.onresize = () => {
      document.documentElement.style.setProperty(
        "font-size",
        (document.body.clientWidth / 375) * 10 + "px"
      );
    };
  },
};
</script>
<style lang="less" scoped>
.third-box .btm-icon {
  width: 2.4rem;
  height: 2.4rem;
}
.third-box {
  height: 100%;
}
.outContent {
  height: calc(100% - 5rem);
}
.guide-box {
  width: 22.2rem;
  height: 8.4rem;
  background: url("~@/assets/third/guide/guide_box2_icon.png") no-repeat;
}
.overlay-box {
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.5);
}
#canvasId {
  position: fixed;
  z-index: 9999999;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.person-icon {
  width: 7.1rem;
  height: 7.1rem;
  position: fixed;
  right: 6rem;
  bottom: calc(constant(safe-area-inset-bottom) / 1.5);
  bottom: calc(env(safe-area-inset-bottom) / 1.5);
  // bottom:0;
}
.dialog-box {
  width: 22.2rem;
  height: 8.4rem;
  position: fixed;
  right: 5.5rem;
  //   bottom: 8rem;
  bottom: calc(8rem + constant(safe-area-inset-bottom) / 1.5);
  bottom: calc(8rem + env(safe-area-inset-bottom) / 1.5);
  background: url("~@/assets/third/guide/guide_box2_icon.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
}
.icon_5x6 {
  width: 3.7rem;
  height: 4rem;
  margin: 1.2rem 1.2rem 3.2rem 1.6rem;
}
.dialog-tips {
  color: #333333;
  font-size: 1.5rem;
  margin: 1.6rem 1.8rem 3.6rem 0;
}
#canvasBox {
  // background:radial-gradient(circle at 20% 10%,transparent 35px, rgba(0,0,0,0.5) 20px) bottom center;
  position: fixed;
  z-index: 9999999;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
}
.dialog-box1 {
  width: 27.2rem;
  height: 8.4rem;
  position: fixed;
  left: 2rem;
  // top: calc(40rem + var(--status-height));
  background: url("~@/assets/third/guide/guide_box1_icon.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
}
.icon_3x4 {
  width: 3.2rem;
  height: 3.2rem;
  margin: 3.15rem 1rem 2.1rem 1.7rem;
}
.dialog-tips1 {
  color: #333333;
  font-size: 1.45rem;
  margin: 2.9rem 0 0 0;
  flex: 1;
}
.close-icon {
  width: 1.2rem;
  height: 1.2rem;
  padding: 1rem;
  margin: 1.2rem 0 0 0;
}
.thirdYearPopup {
  width: 327px;
  height: 437px;
  border-radius: 8px;
  padding: 0 18px;
  box-sizing: border-box;
  text-align: center;
  z-index: 99999999;
  .title {
    color: #333;
    font-size: 18px;
    font-weight: 700;
    height: 65px;
    line-height: 65px;
  }
  .content {
    color: #666;
    font-size: 13px;
    line-height: 21px;
    height: 296px;
    text-align: left;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .thirdYear-btn {
    margin-top: 23px;
    padding: 0 5px;
    border: 0;
    span {
      width: 140px;
      height: 49px;
      line-height: 49px;
      border-top: solid 0.5px #e5e5e5;
      color: #333;
      font-size: 17px;
      float: left;
    }
    .agree {
      color: #fc740c;
      width: 139px;
      border-left: solid 0.5px #e5e5e5;
    }
  }
}
</style>
